<template>
  <div>
    <AuthHeading
        title="Create your new account."
        sub-title="To get started enter your details below."
    />

    <AuthForm is-sign-up />

    <p class="gla-tos text-xs text-primary text-center p-20">
      By clicking "Create" I agree to ClickOn's
      <a
        target="_blank"
        href="https://eventor.app/terms-of-service/"
        class="text-primary underline"
      >
        Terms of Service
      </a>
      and
      <a
        target="_blank"
        href="https://eventor.app/privacy-policy/"
        class="text-primary underline"
      >
        Privacy Policy
      </a>
    </p>
  </div>
</template>

<script>
import AuthHeading from '@/components/auth/AuthHeading';
import AuthForm from '@/components/auth/AuthForm';

export default {
  components: {
    AuthHeading,
    AuthForm,
  },
};
</script>

<style scoped>
</style>
